<!-- impersonation banner: shown while a Super Admin is logged in as another admin -->
<div class="np-impersonate-bar" *ngIf="authService.isImpersonating()">
  <span>Anda login sebagai <b>{{isMe.name}}</b> ({{roleLabel()}}) — mode impersonasi Super Admin.</span>
  <button type="button" [disabled]="isStoppingImpersonate" (click)="stopImpersonate()">
    <i class="fa fa-spinner fa-spin" *ngIf="isStoppingImpersonate"></i> Kembali ke akun Super Admin</button>
</div>

<!-- Top Bar Start -->
<div class="topbar">
  <!-- Navbar -->
  <nav class="navbar-custom">
    <ul class="list-unstyled topbar-nav float-end mb-0">
      <li>
        <button type="button" class="np-theme" (click)="toggleTheme()"
                [title]="isDark() ? 'Mode terang' : 'Mode gelap'"
                [attr.aria-label]="isDark() ? 'Ganti ke mode terang' : 'Ganti ke mode gelap'">
          <svg *ngIf="!isDark()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z"/>
          </svg>
          <svg *ngIf="isDark()" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4.5"/>
            <path d="M12 2v2.2M12 19.8V22M4.9 4.9l1.6 1.6M17.5 17.5l1.6 1.6M2 12h2.2M19.8 12H22M4.9 19.1l1.6-1.6M17.5 6.5l1.6-1.6"/>
          </svg>
        </button>
      </li>
      <li class="dropdown">
        <a class="nav-link dropdown-toggle np-chip" data-bs-toggle="dropdown"
          href="#" role="button" aria-haspopup="false" aria-expanded="false">
          <span class="np-avatar" aria-hidden="true">{{initials()}}</span>
          <span class="np-id hidden-sm">
            <span class="np-name">{{isMe.name}}</span>
            <span class="np-role">{{roleLabel()}}</span>
          </span>
          <svg class="np-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>
        </a>
        <div class="dropdown-menu dropdown-menu-end np-menu">
          <div class="np-menu-head">
            <span class="np-menu-name">{{isMe.name}}</span>
            <span class="np-menu-mail">{{isMe.email}}</span>
          </div>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item np-item" href="javascript:;" (click)="openProfile()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            Profil Saya</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item np-item np-item-danger" href="javascript:;" (click)="openLogout()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/></svg>
            Keluar</a>
        </div>
      </li>
    </ul>
    <!--end topbar-nav-->

    <ul class="list-unstyled topbar-nav mb-0">
      <li>
        <button class="nav-link button-menu-mobile" type="button"
                [title]="isMini() ? 'Besarkan menu' : 'Kecilkan menu'" (click)="toggleSidenav()">
          <!-- expanded: left column filled (the sidebar is visible) · rail: hollow -->
          <svg *ngIf="!isMini()" class="np-burger" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="4.5" width="18" height="15" rx="3"/>
            <path d="M6 4.5h3.6v15H6a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3z" fill="currentColor" stroke="none"/>
          </svg>
          <svg *ngIf="isMini()" class="np-burger" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="4.5" width="18" height="15" rx="3"/>
            <line x1="9.6" y1="4.5" x2="9.6" y2="19.5"/>
          </svg>
        </button>
      </li>
    </ul>
  </nav>
  <!-- end navbar-->
</div>
<!-- Top Bar End -->

<!-- logout confirmation -->
<div class="hds-overlay" *ngIf="isLogoutOpen" (click)="closeLogout()">
  <div class="hds-dialog nl-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="nl-body">
      <span class="nl-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/></svg>
      </span>
      <h3>Yakin ingin keluar?</h3>
      <p>Kamu bisa masuk lagi kapan saja.</p>
    </div>
    <div class="nl-foot">
      <button type="button" class="vl-btn-ghost" (click)="closeLogout()">Batal</button>
      <button type="button" class="nl-btn-danger" (click)="confirmLogout()">Ya, Keluar</button>
    </div>
  </div>
</div>

<!-- profile dialog: the signed-in admin edits their own account -->
<div class="hds-overlay" *ngIf="isProfileOpen" (click)="closeProfile()">
  <div class="hds-dialog np-dialog" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <button type="button" class="np-close" title="Tutup" aria-label="Tutup"
            [disabled]="isSaving" (click)="closeProfile()">&times;</button>
    <form [formGroup]="isForm" (ngSubmit)="onSubmit()">
      <div class="np-head">
        <h3>Profil saya</h3>
        <div class="np-sub">Perbarui identitas akun yang sedang login.</div>
      </div>
      <div class="np-body">
        <div class="vf-grid">
          <div class="vf-field full">
            <label class="vf-label">Nama <span class="req">*</span></label>
            <input type="text" class="vf-input" [class.invalid]="isInvalid('name')"
                   placeholder="Nama lengkap" formControlName="name">
            <div class="vf-error" *ngIf="isInvalid('name')">Nama wajib diisi.</div>
          </div>
          <div class="vf-field">
            <label class="vf-label">Email <span class="req">*</span></label>
            <input type="email" class="vf-input" [class.invalid]="isInvalid('email')"
                   placeholder="nama@email.com" formControlName="email">
            <div class="vf-error" *ngIf="isInvalid('email')">Masukkan alamat email yang valid.</div>
          </div>
          <div class="vf-field">
            <label class="vf-label">Username <span class="req">*</span></label>
            <input type="text" class="vf-input" [class.invalid]="isInvalid('username')"
                   placeholder="Username untuk login" formControlName="username">
            <div class="vf-error" *ngIf="isInvalid('username')">Username wajib diisi.</div>
          </div>
        </div>

        <div class="np-section">
          <span class="np-section-label">Ganti Password</span>
          <div class="vf-grid">
            <div class="vf-field">
              <label class="vf-label">Password Baru</label>
              <input type="password" class="vf-input" [class.invalid]="isInvalid('new_password')"
                     placeholder="Minimal 6 karakter" formControlName="new_password" autocomplete="new-password">
              <div class="vf-hint">Biarkan kosong jika tidak diganti.</div>
              <div class="vf-error" *ngIf="isInvalid('new_password')">Password baru minimal 6 karakter.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Password Saat Ini</label>
              <input type="password" class="vf-input"
                     [class.invalid]="needsCurrentPassword() && isForm.get('current_password').touched"
                     placeholder="Wajib saat ganti password" formControlName="current_password" autocomplete="current-password">
              <div class="vf-error" *ngIf="needsCurrentPassword() && isForm.get('current_password').touched">
                Masukkan password saat ini untuk mengganti password.</div>
            </div>
          </div>
        </div>
      </div>
      <div class="np-foot">
        <button type="button" class="vl-btn-ghost" [disabled]="isSaving" (click)="closeProfile()">Batal</button>
        <button type="submit" class="vl-btn-primary" [disabled]="isSaving">
          <i class="fa fa-spinner fa-spin" *ngIf="isSaving"></i> Simpan Profil</button>
      </div>
    </form>
  </div>
</div>
